<template>
  <div>
    <footer>
      <div class="container">
          <div class="row">
            <div class=" col-12 col-sm-12 col-md-5">
              <div class="row flex-column-reverse text-center">
                <div class="col mt-1">
                  地址:成都市花牌坊街2号(邮编 610031)
                </div>
                <div class="col mt-1">
                  <img src="../../assets/nav/qrcode.jpg" width="120"/>
                  <span class="pt-2 ml-4">微信小程序</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-12 col-md-7">
              <div class="text-center">
                <h6 class="mt-4">友情链接</h6>
                <div class="row">
                  <a :href="item.url" target="_blank" :key="item.id" class="text-reset mt-2  mt-sm-2 mt-md-2 col-6 col-md-6 col-lg-4 col-xl-4"
                     v-for="item of friendshipLink">{{ item.name }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--      <div class="container text-center">-->
<!--        <div class="text-center">-->
<!--          <h6>友情链接</h6>-->
<!--          <div class="row">-->
<!--            <a :href="item.url" target="_blank" :key="item.id" class="text-reset  mb-2 col-6 col-md-4 col-lg-3 col-xl-2"-->
<!--               v-for="item of friendshipLink">{{ item.name }}</a>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="footer_line"></div>-->
<!--        <div class="mt-4">-->
<!--          <img src="../../assets/nav/qrcode.jpg" width="120"/>-->
<!--          <div class="pt-2">微信小程序</div>-->
<!--        </div>-->
<!--        <div class="footer_address">地址:成都市花牌坊街2号(邮编 610031)</div>-->
<!--      </div>-->
      <div class="text-center mt-2">
        Copyright © 2020 <a class="text-reset " href="https://www.baidu.com">四川省模具工业协会</a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'IndexFooter',
  data() {
    return {
      friendshipLink: [
        {id: 1, name: '中国模协', url: 'http://www.cdmia.com.cn/',},
        {id: 2, name: '四川省发改委', url: 'https://fgw.sc.gov.cn//',},
        {id: 3, name: '四川省经济委员会', url: 'https://jxt.sc.gov.cn/',},
        {id: 4, name: '上海模协', url: 'http://www.shmould.cn/',},
        {id: 5, name: '四川铸造协会', url: 'http://www.scfoundry.com/about.asp',},
        {id: 6, name: '四川省汽车工程学会', url: 'https://www.sae-sichuan.org.cn//',},
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../scss/public";
h6{
  //line-height: 40px;
  //margin-bottom: 20px;
}
.footer_line {
  border-top: 1px dashed $footer-font-color1;
  margin: 20px 0;
}
.footer_address{
  line-height: 40px;
}

footer {
  min-height: 10rem;
  background-color: $footer-font-color2;
  color: $footer-font-color1;
  padding: 2rem 2rem 1rem;
}

</style>
